'use client'

import React, { useEffect, useState } from 'react'
import moment, { months } from 'moment'
import CalendarDates from './CalendarDates'
import CalendarEvents from './CalendarEvents'
import { useGetEventsQuery } from '@/redux/services/newsApi'
import CalendarDatesSlider from './CalendarDatesSlider'
import CalendarSliderHead from './CalendarSliderHead'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import s from './Calendar.module.scss'

interface CalendarProps {
    lightTheme?: boolean
}

const Calendar = ({ lightTheme }: CalendarProps) => {
    const [today, setToday] = useState(moment())
    const [targetDate, setTargetDate] = useState(null)
    const [eventsDefault, setEventsDefault] = useState([])
    const { data: events } = useGetEventsQuery()
    const [currentEventsList, setCurrentEventsList] = useState([])
    const { t } = useTranslation()

    useEffect(() => {
        moment.locale('ru')

        moment.updateLocale('ru', {
            week: {
                dow: 1
            }
        })

        setToday(moment())
    }, [])

    useEffect(() => {
        setEventsDefault(
            events?.map(event => ({
                ...event,
                dateFrom: moment(event.dateFrom),
                dateTo: moment(event.dateTo)
            }))
        )
        setEventsDefault(prev => prev?.sort((a, b) => Number(a.dateFrom) - Number(b.dateFrom)))
    }, [events])

    useEffect(() => {
        setCurrentEventsList(eventsDefault)
    }, [eventsDefault])

    const nextMonth = () => {
        setToday(today.clone().add(1, 'month'))
    }

    const prevMonth = () => {
        setToday(today.clone().subtract(1, 'month'))
    }

    const startDay = today.clone().startOf('month').startOf('week')

    return (
        <div className={`calendar__wrapper`}>
            <div className='container'>
                <h2 className={classNames('main__section-title', lightTheme ? s.calendarLightTitle : '')}>
                    {t('eventsTitle')}
                </h2>
            </div>
            <div className='calendar__slider'>
                <CalendarSliderHead
                    today={today}
                    nextMonth={nextMonth}
                    prevMonth={prevMonth}
                />
                <CalendarDatesSlider
                    events={events}
                    setTargetDate={date => setTargetDate(date)}
                    today={today}
                    startDay={startDay}
                />
            </div>
            <div className='calendar'>
                <CalendarDates
                    targetDate={targetDate}
                    eventsDefault={eventsDefault}
                    currentList={currentEventsList}
                    setCurrentList={list => setCurrentEventsList(list)}
                    setTargetDate={date => setTargetDate(date)}
                    nextMonth={nextMonth}
                    prevMonth={prevMonth}
                    today={today}
                    startDay={startDay}
                    lightTheme={lightTheme}
                />
                <CalendarEvents
                    setTargetDate={state => setTargetDate(state)}
                    eventsDefault={eventsDefault}
                    currentList={currentEventsList}
                    setCurrentList={list => setCurrentEventsList(list)}
                    targetDate={targetDate}
                    lightTheme={lightTheme}
                />
            </div>
        </div>
    )
}

export default Calendar
